import React, { useContext } from 'react';
import styled from 'styled-components/macro';

import { lessonsPalette } from '@mirinae/lessons/modules/defines/styles';
import PlayerContext from '@mirinae/lessons/modules/contexts/player';
import Element from '@mirinae/lessons/components/lesson/elements/Element';

const TitleWrapper = styled.div`
    display: flex;
    flex-direction: column;
`;

const TitleGroup = styled.div`
    display: flex;
    flex-direction: row;
    position: relative;
    justify-content: center;
`;

const MainTitle = styled.div`
    font-family: Noto Sans KR;
    font-style: normal;
    font-weight: bold;
    font-size: 144px;
    line-height: 213px;
    text-align: center;
    padding: 0 80px;
    color: #000;
`;

const LevelTag = styled.div`
    position: absolute;
    right: 0px;
    top: 50%;
    padding: 2px 8px;
    background: ${lessonsPalette.primary.main};
    border-radius: 20px;
    font-family: Montserrat;
    font-size: 24px;
    line-height: 29px;
    text-align: center;
    color: ${lessonsPalette.primary.white};
`;

const SubTitle = styled.div`
    font-size: 48px;
    line-height: 59px;
    text-align: center;
    color: ${lessonsPalette.primary.black};
`;

const OldPatternTitle = ({ element }) => {
    const player = useContext(PlayerContext);

    return (
        <Element element={element}>
            <TitleWrapper>
                <TitleGroup>
                    <MainTitle>{player.fieldValue(element, 'title')}</MainTitle>
                    <LevelTag>{player.fieldValue(element, 'levelTitle')}</LevelTag>
                </TitleGroup>
                <SubTitle>{player.fieldValue(element, 'subtitle')}</SubTitle>
            </TitleWrapper>
        </Element>
    );
};

export default OldPatternTitle;
